

import React, { Fragment } from 'react'
import { Card, Col, Container, Row, Button, CardBody, Input } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useCurvesTimes } from '../../../hooks/curvesTimes/useCurvesTimes';
import { DialogCurveTime } from './DialogCurveTime';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';

export const IndexTimeCurves = () => {

  const {
    curvesTimes, method,
    label, time_in_minutes, handleInputChange, validations,
    toggle, modal, modalTitle, loading,time_valid, label_valid,
    handleCreate, saveCreate,
    handleUpdate, saveUpdate,
    handleDelete, saveDelete, handleSearch, curveTimeSearch,
    closeModalCurves, handleClearSearch, searchCurves

  } = useCurvesTimes();

  const headerStyle = {
    backgroundColor: "#1d5b83",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "11px",
    borderRight: "1px solid #fff",
    borderBottom: "2px solid #fff",
  };

  const cellStyle = {
    fontSize: "11px",
    padding: "5px",
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",

  };

  const centerStyle = {
    ...cellStyle,
    textAlign: "center",
  };

   const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_curve_time)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_curve_time)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };

  return (
    <Fragment>
      <div className='container-global-zoom' >
        <Row>
          <Col sm="12">
            <Card>
                <CardBody className='p-1'>
                    <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                        <TitleDataTable
                            titleTable="Tiempos de Curvas"
                            showExportButton={false} 
                            titleCreate="Crear Curva"
                            buttonActionsCreate={handleCreate}
                            actionInput={handleSearch}
                            valueFilter={searchCurves}
                            filterLocalStorage={true}
                            cleanFilterLocalStorage={handleClearSearch}
                        />
                    </Col>
                
                    <div className="table-responsive">
                        <DataTable
                            value={curveTimeSearch}
                            paginator
                            rows={10}
                            responsiveLayout="scroll"
                            rowsPerPageOptions={[10, 50, 100]}
                            className="data-table p-datatable-striped p-datatable-sm"
                            emptyMessage={
                            <div className="text-center">
                                <img
                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                style={{ width: "32%" }}
                                alt="Sin resultados"
                                />
                                <br />
                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                No se encontraron resultados.
                                </p>
                            </div>
                            }
                        >

                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                            <Column field="label" header="Nombre del tiempo" headerStyle={headerStyle} style={cellStyle} />
                            <Column field="time_in_minutes" header="Tiempo en minutos" headerStyle={headerStyle} style={cellStyle} />
                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />

                        </DataTable>
                    </div>
                </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <DialogCurveTime
        {
        ...{
          modal, toggle, modalTitle, method, loading, handleInputChange,
          saveCreate, saveUpdate, saveDelete, validations, time_in_minutes, label, label_valid, time_valid, closeModalCurves
        }
        }

      />

    </Fragment>
  )
}
